// extracted by mini-css-extract-plugin
var _1 = "ReactionAvatar-module__animateUploadProgressBarWidth--W9fB9";
var _2 = "ReactionAvatar-module__animatedBackground--wqMt4";
var _3 = "ReactionAvatar-module__avatar--SUqCt";
var _4 = "ReactionAvatar-module__container--ES_Ln";
var _5 = "ReactionAvatar-module__emoji--xgwXK";
var _6 = "ReactionAvatar-module__isActive--cBmXe";
var _7 = "ReactionAvatar-module__isHighlighted--MEwRf";
var _8 = "ReactionAvatar-module__isWithinOverlay--Lc0E9";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatar", _4 as "container", _5 as "emoji", _6 as "isActive", _7 as "isHighlighted", _8 as "isWithinOverlay" }
